import { GoogleCalendarFeed } from "./GoogleCalendarImporter";
export const CALENDARS: GoogleCalendarFeed[] = [
  { slug: "hfcs", calendar: "holy_family%40holyfamily.dbq.pvt.k12.ia.us", title: "Holy Family Schools", color: "#CC9E08", isFixed: true },
  {
    slug: "wchs",
    calendar: "wahlert_website_calendar%40holyfamily.dbq.pvt.k12.ia.us",
    title: "Wahlert",
    color: "#00689E"
  },
  {
    slug: "st-columbkille",
    calendar: "st_columbkille_website_calendar%40holyfamily.dbq.pvt.k12.ia.us",
    title: "St. Columbkille",
    color: "#4D1D41"
  },
  {
    slug: "our-lady-of-guadalupe",
    calendar: "our_lady_website_calendar%40holyfamily.dbq.pvt.k12.ia.us",
    title: "Our Lady of Guadalupe",
    color: "#B62C62"
  },
  {
    slug: "resurrection",
    calendar: "resurrection_website_calendar%40holyfamily.dbq.pvt.k12.ia.us",
    title: "Resurrection",
    color: "#EE6342"
  },
  {
    slug: "holy-ghost",
    calendar: "holy_ghost_website_calendar%40holyfamily.dbq.pvt.k12.ia.us",
    title: "Holy Ghost",
    color: "#529E2F"
  },
  {
    slug: "mazzuchelli",
    calendar: "mazzuchelli_website_calendar%40holyfamily.dbq.pvt.k12.ia.us",
    title: "Mazzuchelli",
    color: "#494D6B"
  },
  {
    slug: "st-anthony",
    calendar: "st_anthony_website_calendar%40holyfamily.dbq.pvt.k12.ia.us",
    title: "St. Anthony",
    color: "#851F3E"
  },
];
